const TAG_RE = /<\/?[a-z][\s\S]*>/i;
export const MESSAGE_TEXT_MAX = 4000;

export function messageHasTags(value: string) {
  return TAG_RE.test(String(value || ""));
}

/** Visible text. A body with no tags is returned unchanged. */
export function messagePlain(value: string) {
  const raw = String(value || "");
  if (!messageHasTags(raw)) return raw;
  return raw
    .replace(/<\/(p|div|h[1-6]|li|tr|blockquote)\s*>/gi, "\n")
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

export function messageReady(value: string) {
  const plain = messagePlain(value).trim();
  return plain.length > 0 && plain.length <= MESSAGE_TEXT_MAX;
}

export function plainToMessageHtml(value: string) {
  const raw = String(value || "");
  if (!raw.trim()) return "";
  if (messageHasTags(raw)) return raw;
  return raw
    .split(/\n{2,}/)
    .map(
      (para) =>
        `<p>${para
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/\n/g, "<br>")}</p>`,
    )
    .join("");
}
